import { render, staticRenderFns } from "./review-agent-notes.vue?vue&type=template&id=509d7e87"
import script from "./review-agent-notes.vue?vue&type=script&lang=js"
export * from "./review-agent-notes.vue?vue&type=script&lang=js"
import style0 from "./review-agent-notes.vue?vue&type=style&index=0&id=509d7e87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports